import React from "react";
import "./HeaderBar.css";

function HeaderBar() {
  return (
    <div className="headerBar">

    </div>
  );
}

export default HeaderBar;